import { render } from "./CalendarioView.vue?vue&type=template&id=27ff20c6&scoped=true"
import script from "./CalendarioView.vue?vue&type=script&lang=js"
export * from "./CalendarioView.vue?vue&type=script&lang=js"

import "./CalendarioView.vue?vue&type=style&index=0&id=27ff20c6&scoped=true&lang=css"
import "./CalendarioView.vue?vue&type=style&index=1&id=27ff20c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ff20c6"]])

export default __exports__